import { useEffect } from "react";

function AdCashLoader({ zoneId }) {
  useEffect(() => {
    if (!zoneId) return;

    if (!document.getElementById("aclib")) {
      const script = document.createElement("script");
      script.id = "aclib";
      script.src = "//acscdn.com/script/aclib.js";
      script.async = true;
      script.onload = () => {
        console.log("✅ aclib.js successfully loaded!");
        if (window.aclib && typeof window.aclib.runAutoTag === "function") {
          window.aclib.runAutoTag({ zoneId });
        } else {
          console.warn("❌ aclib.js not ready yet!");
        }
      };
      document.body.appendChild(script);
    } else {
      if (window.aclib && typeof window.aclib.runAutoTag === "function") {
        window.aclib.runAutoTag({ zoneId });
      } else {
        console.warn("❌ aclib.js not found!");
      }
    }
  }, [zoneId]);

  return null;
}

export default AdCashLoader;
